import React, { type ReactNode } from "react";
import { Panel } from "../Panel";

import { sanitiseString } from "../../Utils";

export interface Props {
  text: string;
  children?: ReactNode;
  id: string;
  dataTestId?: string;
  classes?: string;
}

export const Error = (props: Props) => {
  const sanitisedId: string = sanitiseString(props.id);
  const sanitisedDataTestId: string = sanitiseString(props.dataTestId);

  return (
    <Panel
      variant="error"
      id={sanitisedId}
      dataTestId={sanitisedDataTestId}
      classes={props.classes}
    >
      <p className="ons-panel__error">
        <strong>{props.text}</strong>
      </p>
      {props.children}
    </Panel>
  );
};
